// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"a7c369a4","667":"f9797dd8","871":"1d909ac3","977":"6454ef3f"}[chunkId] + ".chunk.js";
};